import type { PayloadAction } from "@reduxjs/toolkit";
import type {
  currentSurveySliceState,
  CustomField,
} from "@survey-types/survey.core.types";

export const customFieldReducers = {
  addCustomField: (
    state: currentSurveySliceState,
    action: PayloadAction<CustomField>,
  ) => {
    if (state.currentSurvey?.properties) {
      state.currentSurvey.properties = state.currentSurvey.properties.map(
        (property) => {
          if (property.id === state.currentPropertyId) {
            return {
              ...property,
              customFields: property.customFields.concat({
                customField: action.payload,
                value: "",
              }),
            };
          }
          return property;
        },
      );
    }
  },
  updateCustomField: (
    state: currentSurveySliceState,
    action: PayloadAction<CustomField>,
  ) => {
    if (state.currentSurvey?.properties) {
      state.currentSurvey.properties = state.currentSurvey.properties.map(
        (property) => {
          if (property.id === state.currentPropertyId) {
            return {
              ...property,
              customFields: property.customFields.map((field) => {
                if (
                  field.customField.customFieldId ===
                  action.payload.customFieldId
                ) {
                  return {
                    ...field,
                    customField: { ...field.customField, ...action.payload },
                  };
                }
                return field;
              }),
            };
          }
          return property;
        },
      );
    }
  },

  deleteCustomField: (
    state: currentSurveySliceState,
    action: PayloadAction<string>,
  ) => {
    if (state.currentSurvey?.properties) {
      state.currentSurvey.properties = state.currentSurvey.properties.map(
        (property) => {
          if (property.id === state.currentPropertyId) {
            return {
              ...property,
              customFields: property.customFields.filter(
                (field) => field.customField.customFieldId !== action.payload,
              ),
            };
          }
          return property;
        },
      );
    }
  },
};
